import { Document } from '@contentful/rich-text-types';
import { CloudinaryProductAsset, ContentfulProduct } from 'shared/types/content';
import {
  UIProductContent,
  UIProductGuide,
} from '../../components/commercetools-ui/organisms/product/product-details/types';
import { ImageProps } from '../../components/commercetools-ui/atoms/image';

export const toUIProductContent = (
  content: ContentfulProduct | undefined,
  assets: CloudinaryProductAsset[] | undefined,
): UIProductContent => {
  const images: ImageProps[] = [];
  const productGuides: UIProductGuide[] = [];

  if (assets)
    for (const asset of assets) {
      const mediaId = `v${asset.version}/${asset.publicId}`;
      if (['jpg', 'png', 'webp'].includes(asset.format))
        images.push({ src: asset.publicId, alt: asset.alt, media: { mediaId, alt: asset.alt } });
      else if (asset.format === 'pdf')
        productGuides.push({
          id: mediaId,
          reference: asset.url,
          title: asset.caption ?? asset.publicId,
        });
    }

  return {
    description: content?.attributes?.description as Document | undefined,
    additionalDetails: content?.attributes?.additionalDetails?.map((item) => ({
      id: item.contentId,
      text: item.attributes?.text as unknown as Document,
      icon: item.attributes?.icon?.[0],
    })),
    frequentlyAskedQuestions: content?.attributes?.frequentlyAskedQuestions?.map((item) => ({
      id: item.contentId,
      question: item.attributes?.question ?? '',
      answer: item.attributes?.answer as unknown as Document,
    })),
    images,
    productGuides,
  };
};
